<template>
  <div class="wrapper d-flex flex-column">
    <!-- Navbar -->
    <nav class="navbar navbar-expand navbar-white navbar-light d-flex justify-content-between ml-0">
      <!-- Left navbar links -->

      <div class="brand-link">
        <img id="dashboard-logo"
             src="@/assets/images/logo_red.png"
             class="brand-image align-self-center" />
      </div>

      <ul class="nav nav-pills nav-sidebar flex-row ml-5 align-self-end">
        <li class="nav-item"
            v-for="(menuItem, index) in menus"
            :key="index">
          <router-link :to="{ name: menuItem.pathName[0] }"
                       class="nav-link"
                       :class="{ active: markActive(menuItem) }">
            <i class="nav-icon"
               :class="menuItem.icon"></i>
            <p>{{ menuItem.title }}</p>
          </router-link>
        </li>
      </ul>

      <ul class="navbar-nav">
        <li class="nav-item">
          <div class="d-flex">
            <div class="dropdown user-dropdown mr-0 mt-2 mr-md-4 align-self-center">
              <div class="handler d-flex"
                   data-toggle="dropdown">
                <span class="text-color-4 align-self-center">{{
              username
            }}</span>
                <i class="fal fa-chevron-down text-color-4 align-self-center"></i>
              </div>

              <div class="dropdown-menu dropdown-menu-left text-color-2 --text-sm">
                <router-link v-if="isSeller"
                             :to="{ name: 'Seller-Settings-Account' }"
                             class="dropdown-item text-color-2">
                  <i class="fal fa-cog mr-1"></i>
                  {{ $t("general.settings") }}
                </router-link>
                <a class="dropdown-item text-color-2"
                   href="#"
                   @click="logout()">
                  <i class="fal fa-sign-out mr-1"></i>
                  {{ $t("general.logout") }}
                </a>
              </div>
            </div>
          </div>
        </li>

        <li class="nav-item"></li>
      </ul>
    </nav>
    <!-- /.navbar -->

    <!-- Content Wrapper. Contains page content -->
    <div class="container">
      <slot></slot>
    </div>
    <!-- /.content-wrapper -->
  </div>
</template>

<script>
import Modal from "@/components/core/Modal";
import Toggle from "@/components/core/Toggle";
import Button from "@/components/core/Button";
import Stepper from "@/components/core/Stepper";
import TextBox from "@/components/core/TextBox";
import NumberField from "@/components/core/NumberField";
import DatePicker from "@/components/core/DatePicker";
import { mapGetters } from "vuex";
import { i18n } from "@/i18n";
import Select from "@/components/core/Select";

export default {
  name: "Seller",
  components: {
    Modal,
    TextBox,
    DatePicker,
    NumberField,
    Stepper,
    Button,
    Toggle,
    Select,
  },
  data() {
    return {
      permissionOptions: [
        { name: "Manage only products", value: 0 },
        { name: "Manage only orders", value: 1 },
        { name: "Manage both orders & products", value: 2 },
      ],
      buttonLoading: false,
      flashNotifyLoading: false,
      currentRoute: null,
      addBalanceForm: {
        date: null,
        time: null,
        amount: null,
        taxInvoice: null,
        slips: null,
      },
      menus: null,
      totalBalance: null,
      socketMsg: null,
      selectedFlashShop: null,
      selectedFlashWarehouse: null,
      flashTicketInfo: null,
      fbPageIdsChecker: {
        loading: false,
        status: false,
        pageIds: {},
        errorShop: null,
        total: 0,
        lastUpdatedAt: null
      }
    };
  },

  created() {
    this.initNavbarMenu();
    this.setCurrentRoute(this.$route);


    // socket ec2
    // let socketUrl = "http://localhost:5000/";
    // let socketUrl = "https://jobs.proship.co.th/";
    // var socket = io(socketUrl, {
    //   query: "username=" + this.username,
    // });
    // socket.on("message", (message) => {
    //   this.socketMsg = message;
    // });

    // websocket-lamda
    // let ws = initWs();
    // ws.addEventListener("message", (event) => handleMessage(event));
  },

  mounted() {
    if (localStorage.getItem("darkmode") && localStorage.getItem("darkmode") === "true") {
      this.toggleColorMode()
    }
  },

  destroyed() {
    clearInterval(this.timer);
  },

  methods: {
    toggleColorMode() {
      this.colorMode = !this.colorMode;
      if (document.body.classList.contains("--dark")) document.body.classList.remove("--dark")
      else document.body.classList.add("--dark")

      localStorage.setItem("darkmode", this.colorMode);
    },

    markActive(menuItem) {
      let includes = menuItem.pathName.includes(this.currentRoute);
      // if (includes) debugger;
      return includes;
    },

    initNavbarMenu() {
      // pathname can contain multiple values
      // routed to the 1st one only
      this.menus = [
        {
          title: i18n.t("dashboard.dashboard_label"),
          icon: "fal fa-tachometer-fastest",
          pathName: ["Seller-Dashboard", "Seller-Home", "Dash-Intro"],
        },

        {
          title: "บิลจัดส่ง",
          icon: "fal fa-receipt",
          pathName: [
            "Seller-Bill-List",
            "Seller-Bill-Show",
            "Seller-Bill-Create",
            "Seller-Bill-Edit",
          ],
        },

        {
          title: "ลูกค้า",
          icon: "fal fa-users",
          pathName: [
            "Seller-Shippers",
          ],
        },

        {
          title: i18n.t("reports.label"),
          icon: "fal fa-chart-line",
          pathName: ["Reports-Shipments"],
        },

        {
          title: i18n.t("general.settings"),
          icon: "fal fa-cogs",
          pathName: [
            "Seller-Settings-Account",
            "Seller-Settings-Shipping",
            "Seller-Settings-Pricing",
            "Seller-Settings-Checkout",
          ],
        }
      ];
    },

    logout() {
      this.$store.dispatch("user/logout", {
        callback: () => {
          clearInterval(this.timer);
          this.$router.push({ name: "Login" });
        },
      });
    },

    setCurrentRoute(route) {
      this.currentRoute = route.name;
    }
  },

  computed: {
    ...mapGetters({
      generalSettings: "settings/generalSettings",
      shippingMethods: "settings/shippingMethods",
      flashWarehouses: "settings/flashWarehouses",
      shops: "shops/shops",
    }),
    ...mapGetters("user", ["authData"]),

    username() {
      if (this.authData && this.authData.user && this.authData.user.username)
        return this.authData.user.username;
      return "User";
    },

    isSeller() {
      if (this.authData && this.authData.user && this.authData.user.role)
        return this.authData.user.role === "seller";
      return false;
    },

    isThaipostUser() {
      return this.generalSettings && this.generalSettings.thaiPostUserName;
    },

    isFlashUser() {
      return this.shippingMethods && this.shippingMethods.includes("flash");
    },

    flashShops() {
      if (this.shops) {
        return this.shops
          .filter((s) => s.details.shippingMethods.includes("flash"))
          .map((s) => {
            return {
              value: s.id,
              name: s.details.name,
            };
          });
      }
    },
  },

  watch: {
    $route(to, from) {
      this.setCurrentRoute(to);
    },
  },
};
</script>

<style lang="scss">
.container {
  width: 100%;
  padding-right: var(--container-padding, 1rem);
  padding-left: var(--container-padding, 1rem);
  margin-right: auto;
  margin-left: auto;
  max-width: var(--container-max-width, 100%);
  padding-top: 2rem;
}

/* Define breakpoints similar to Tailwind's default settings */
@media (min-width: 640px) {
  :root {
    --container-max-width: 640px;
  }
}

@media (min-width: 768px) {
  :root {
    --container-max-width: 768px;
  }
}

@media (min-width: 1024px) {
  :root {
    --container-max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  :root {
    --container-max-width: 1280px;
  }
}

.nav-icon {
  margin-right: 1.5rem !important;
}

.navbar {
  padding-bottom: 0 !important;
}

.nav-link {
  margin-bottom: 0 !important;
  margin-right: 1rem;
  border-bottom: 4px solid white;

  &.active {
    background: white !important;
    border-bottom: 4px solid red;
    color: inherit !important;
    border-radius: 0 !important;
  }
}

.nav-link.active {}

// ------------------Override styles-----------

.brand-link {
  position: relative !important;
  border-bottom: none;
  height: auto !important;

  .brand-image {
    margin-left: 0.4rem;
    max-height: 33px !important;
    border-radius: 100%;

    @include for-desktops-and-up {
      max-height: 59px;
    }

    transition: all 0.2s ease-in-out;
  }

  .brand-text {
    font-size: 1rem;
    line-height: 16px;
    color: red;
  }
}


.user-dropdown {
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }

  span {
    margin-right: 8px;
  }

  .dropdown-menu {
    left: 50%;
    transform: translate(-50%);
  }
}

.navbar {
  box-shadow: none !important;
  border-bottom: 1px solid lightgrey;
}
</style>